import type { ReactNode } from "react";
import { Box, Button, Icon } from "@salestrak/ui";

/**
 * The manage-dialog pane header (the `MANAGE_DIALOG_SURFACE` takeovers and
 * the `size="window"` dialogs alike — Custom Fields, App Center, keyboard
 * shortcuts): a 48px bordered bar with the surface's identity on the left and
 * the pill close on the right, so every manager surface reads with the same
 * type and rhythm regardless of its frame. Automations' richer
 * screen header (back button, centered tabs, measured width) shares this
 * grammar in `automations-header.tsx`. `actions` seats the surface's own
 * icon-only controls ahead of the close, on the same rung.
 */
export function ManageDialogHeader({
  children,
  actions,
  onClose,
}: {
  children: ReactNode;
  actions?: ReactNode;
  onClose?: () => void;
}) {
  return (
    <Box
      align="center"
      border="bottom"
      direction="row"
      gap="sm"
      height={48}
      justify="between"
      paddingX="md"
    >
      {children}
      {actions || onClose ? (
        <Box align="center" direction="row" gap="xs" shrink={false}>
          {actions}
          {onClose ? (
            <Button
              aria-label="Close"
              size="icon-xs"
              color="neutral"
              onClick={onClose}
            >
              <Icon name="x" />
            </Button>
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
}
